import { render, staticRenderFns } from "./Tab.htm?vue&type=template&id=1b687687&scoped=true&"
import script from "./Tab.ts?vue&type=script&lang=js&"
export * from "./Tab.ts?vue&type=script&lang=js&"
import style0 from "./Tab.scss?vue&type=style&index=0&id=1b687687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b687687",
  null
  
)

export default component.exports